export const StarBoldSmallOutlineBannerRatingGiven = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="26" viewBox="0 0 28 26" width="28">
    <path
      d="m12.578 1.36036-3.24166 6.49165-7.33114 1.025c-1.296669.19523-1.795386 1.75709-.84782 2.68449l5.23653 5.0274-1.24679 7.0774c-.19949 1.269 1.19692 2.2452 2.34397 1.6595l6.53321-3.3679 6.4833 3.3679c1.1471.5857 2.5435-.3905 2.344-1.6595l-1.2468-7.0774 5.2365-5.0274c.9476-.9274.4489-2.48926-.8478-2.68449l-7.2813-1.025-3.2915-6.49165c-.5486-1.122613-2.2442-1.171422-2.8427 0z"
      fill="#292b29"
    />
  </svg>
);
